var tablet_break = 980;
var max_wrap = 1200;
var bank_name = "University of Kentucky Credit Union";
